import React from 'react';
import ReactDOM from 'react-dom';

/**
 * Renders a stack of toast notifications at the bottom-right of the screen.
 * Uses a React portal so toasts always appear above modals and overlays.
 */
export function ToastContainer({ toasts }) {
  if (!toasts || toasts.length === 0) return null;

  return ReactDOM.createPortal(
    <div className="toast-container" role="region" aria-label="Notifications">
      {toasts.map(t => (
        <div
          key={t.id}
          className={`toast toast-${t.type}`}
          role="alert"
          aria-live={t.type === 'error' ? 'assertive' : 'polite'}
        >
          <span className="toast-icon">
            {t.type === 'success' && '✓'}
            {t.type === 'error'   && '✕'}
            {t.type === 'warn'    && '⚠'}
            {t.type === 'info'    && 'ℹ'}
          </span>
          <span className="toast-message">{t.message}</span>
          {/* Optional action (C11's Undo). Rendered only when the toast carries
              one, so every existing toast is unaffected. */}
          {t.action && (
            <button
              type="button"
              className="toast-action"
              onClick={() => t.action.onAction(t.id)}
              style={{
                width: 'auto', marginLeft: '0.6rem', padding: '0.15rem 0.5rem',
                background: 'rgba(255,255,255,0.2)', border: '1px solid currentColor',
                borderRadius: '4px', color: 'inherit', cursor: 'pointer',
                font: 'inherit', flexShrink: 0,
              }}
            >
              {t.action.label}
            </button>
          )}
        </div>
      ))}
    </div>,
    document.body
  );
}
